import React from "react";
import { Controller, FieldErrors, Control } from "react-hook-form";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { SxProps, Theme } from "@mui/material";

export interface Option {
  value: string;
  label: React.ReactNode;
}

interface AutocompleteSelectProps {
  fieldName: string;
  label: string;
  control: Control<any, any>;
  errors: FieldErrors<any>;
  options: Option[];
  fontSize?: number;
  width?: number | string;
  style?: React.CSSProperties;
  sx?: SxProps<Theme>;
  onChange?: (newValue: any) => void;
}

export default function SelectInputSeverity(props: AutocompleteSelectProps) {
  const {
    sx,
    fieldName,
    control,
    fontSize,
    errors,
    width,
    label,
    options,
    onChange,
    ...otherProps
  } = props;
  const errorMessage = errors[fieldName]?.message as string | undefined;

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field }) => (
        <Autocomplete
          {...otherProps}
          options={options}
          getOptionLabel={(option: Option) => option.label?.toString() ?? ""}
          sx={{ ...sx }}
          renderInput={(params) => (
            <TextField
              {...params}
              style={props.style}
              size="small"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "4px",
                },
              }}
              inputProps={{
                ...params.inputProps,
                style: { fontSize: fontSize ?? 14 },
              }}
              InputLabelProps={{
                style: { fontSize: fontSize ?? 14 },
              }}
              label={
                field.value
                  ? options.find((option) => option.value === field.value)
                      ?.label
                  : label
              }
              error={!!errors[fieldName]}
              helperText={errorMessage}
            />
          )}
          value={
            field.value
              ? options.find((option) => option.value === field.value)
              : null
          }
          onChange={(_, newValue: Option | null) => {
            field.onChange(newValue?.value || null);
            onChange?.(newValue?.value || "");
          }}
        />
      )}
    />
  );
}
